
import { defineComponent, ref } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";

export default defineComponent({
  name: "sign-in-idcard",
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const submitButton = ref<HTMLButtonElement | null>(null);

    const loginSchema = Yup.object().shape({
      idCard: Yup.string()
        .matches(/^\d{13}$/, "กรุณากรอกเลขบัตรประชาชน 13 หลักให้ถูกต้อง")
        .required("กรุณากรอกเลขบัตรประชาชน"),
    });

    const onSubmitLogin = async (values) => {
      if (submitButton.value) {
        submitButton.value.disabled = true;
        submitButton.value.setAttribute("data-kt-indicator", "on");
      }

      await store.dispatch(Actions.LOGIN_THAI, { idCard: values.idCard });
      const [errorName] = Object.keys(store.getters.getErrors);
      const error = store.getters.getErrors[errorName];
      const adminRole = store.getters.currentUserAdminRole;

      if (!error) {
        localStorage.setItem("typeLogin", "idcard");
        if (adminRole == 4) {
          router.push({ name: "certificate-approve" });
        } else {
          router.push({ name: "my-exam" });
        }
      } else {
        Swal.fire({
          text: error,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "ลองใหม่ภายหลัง!",
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
      }

      submitButton.value?.removeAttribute("data-kt-indicator");
      submitButton.value!.disabled = false;
    };

    const onlyNumbers = (e: KeyboardEvent) => {
      if (!/\d/.test(e.key)) e.preventDefault();
    };

    return {
      onSubmitLogin,
      loginSchema,
      submitButton,
      onlyNumbers,
    };
  },
});
